const API_BASE = ''

export type UserData = {
  gamesPlayed: number
  gamesWon: number
  totalGuesses: number
  redeemCode?: string | null
}

export async function registerUser(username: string, pin: string): Promise<{ ok: boolean; error?: string; needLogin?: boolean; user?: UserData }> {
  const res = await fetch(`${API_BASE}/api/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, pin }),
  })
  return res.json()
}

export async function loginUser(username: string, pin: string): Promise<{ ok: boolean; error?: string; user?: UserData }> {
  const res = await fetch(`${API_BASE}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, pin }),
  })
  return res.json()
}

export async function submitResult(
  username: string,
  guessCount: number,
  won: boolean
): Promise<{ ok: boolean; redeemCode?: string; user?: UserData }> {
  const pin = localStorage.getItem('pin') || ''
  const res = await fetch(`${API_BASE}/api/result`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, pin, guessCount, won }),
  })
  return res.json()
}

export type LeaderboardEntry = {
  username: string
  gamesPlayed: number
  gamesWon: number
  averageGuesses: number | null
  winRate: number | null
}

export type LeaderboardData = {
  leaderboard: LeaderboardEntry[]
  registeredPlayers: LeaderboardEntry[]
  minGames: number
}

export async function getLeaderboard(): Promise<LeaderboardData> {
  const res = await fetch(`${API_BASE}/api/leaderboard`)
  const data = await res.json()
  return {
    leaderboard: data.leaderboard || [],
    registeredPlayers: data.registeredPlayers || [],
    minGames: data.minGames || 10,
  }
}

export async function getUserStats(username: string): Promise<UserData | null> {
  const pin = localStorage.getItem('pin') || ''
  const res = await loginUser(username, pin)
  return res.ok && res.user ? res.user : null
}
